import { defineMessages } from '@kyruus/intl';

export const messages = defineMessages({
  noResultsNoSearchTerm: {
    id: 'noresults.noresults',
    description:
      'Description shown when no results are found and the search had no search term',
    defaultMessage: 'No results match your search.'
  },
  noResultsFor: {
    id: 'noresults.noresultsFor',
    description: 'Description shown when no results are found for the search',
    defaultMessage: 'No results for "{searchTerm}"'
  },
  noResultsSubtitle: {
    id: 'noresults.subtitle',
    description:
      'Subtitle on no results page with guidance on how to modify query to get results',
    defaultMessage:
      'Try a common search below, clear any filters, or check your spelling and use fewer words.'
  },
  suggestedSearchesHeading: {
    id: 'noresults.suggestedSearchesHeading',
    description:
      'Heading for the suggested searches section on the no results page',
    defaultMessage: 'Suggested Searches'
  },
  commonSearchesHeading: {
    id: 'noresults.commonSearchesHeading',
    description:
      'Heading for the common searches section on the no results page',
    defaultMessage: 'Common Searches'
  }
});
